export default __webpack_public_path__ + "static/media/hrm.7055bfa3.png";